import { FormattedMessage } from "react-intl";
import "../styles/LandingFeatureBlock.css";

const LandingFeatureBlock = () => {
  const featureList = [ {
    featureImage: "/img/img_locate_web.png",
    featureNameId: "landing_page_locate",
    featureDescriptionId: "landing_page_locate_description",
    androidOnly: false,
  }, {
    featureImage: "/img/img_alarm_web.png",
    featureNameId: "landing_page_alarm",
    featureDescriptionId: "landing_page_alarm_description",
    androidOnly: false,
  }, {
    featureImage: "/img/img_lock_web.png",
    featureNameId: "landing_page_wipe",
    featureDescriptionId: "landing_page_wipe_description",
    androidOnly: true,
  }, {
    featureImage: "/img/img_lock_web.png",
    featureNameId: "landing_page_lock",
    featureDescriptionId: "landing_page_lock_description",
    androidOnly: true,
  },];

  const androidOnlySpan = () => {
    return (
      <span className="landingfeatureblock-android-only">
        <FormattedMessage id="landing_page_android_only" />
      </span>
    );
  };

  return (
    <div className="landingfeatureblock">
      <div className="landingfeatureblock-slogan">
        <h4>
          <FormattedMessage id="landing_page_description_main_function" />
        </h4>
      </div>
      <div className="landingfeatureblock-feautres">
        { featureList.map(feature => {
          return(
            <div className="landingfeatureblock-feautre" key={ feature.featureNameId }>
              <img className="landingfeatureblock-feautre-img" src={ feature.featureImage } alt="feature" />
              <div className="landingfeatureblock-feautre-title">
                <h6>
                  <FormattedMessage id={ feature.featureNameId } />
                </h6>
                { feature.androidOnly ? androidOnlySpan() : null }
              </div>
              <p>
                <FormattedMessage id={ feature.featureDescriptionId } />
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LandingFeatureBlock;
